// packages/core/primitive/src/primitive.tsx
function composeEventHandlers(originalEventHandler, ourEventHandler) {
  let {
    checkForDefaultPrevented = true
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function handleEvent(event) {
    originalEventHandler?.(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) {
      return ourEventHandler?.(event);
    }
  };
}
export { composeEventHandlers };